
export default {
  namespaced: true,
  state: {
    user: sessionStorage.user ? JSON.parse(sessionStorage.getItem('user')) : null,
  },
  getters: {
    user: state => state.user,
    authenticated: state => state.user !== null,
    role: state => {
      if (!state.user) return null;
      // El back devuelve user.role.name (ej: 'CORE_ARCHITECT')
      return state.user.user?.role?.name || state.user.role?.name || null;
    },
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
    }
  },
  actions: {
    async login({ commit }, dataUser) {

      commit('SET_USER', dataUser)
      
    },
    async logout({ commit }) {
      try {
        const data = { route: 'api/auth/logout' };
        let http = null;
        try {
          http = (await import('@/api/api.js')).default;
        } catch (e) {
          http = (await import('../../api/api.js')).default;
        }
        await http.post(data);
      } catch (e) {
        console.error('Error cerrando sesión en backend:', e);
      }
      commit('SET_USER', null);
      sessionStorage.clear();
    },
    // async resetPassword({ commit }, forgotEmail) {
    //     const { data } = await repository.resetPassword({
    //         email: forgotEmail
    //     })

    //     if (data?.success) {
    //         return data
    //     } else if (data?.error) {
    //         return {
    //             error: true,
    //             data
    //         }
    //     }
    // },
    // async setNewPassword({ commit }, params) {
    //     const { data } = await repository.setNewPassword(params)

    //     if (data?.success) {
    //         return data
    //     } else if (data?.error) {
    //         return {
    //             error: true,
    //             data
    //         }
    //     }
    // }
}
}